import * as CookieConsent from "vanilla-cookieconsent"
import { cookieConsentConfig } from "./config"

let initialized = false

export function initCookieConsent() {
  if (initialized) return
  initialized = true
  CookieConsent.run(cookieConsentConfig)
}

export function hasAnalyticsConsent() {
  return CookieConsent.acceptedCategory("analytics")
}

export function hasMarketingConsent() {
  return CookieConsent.acceptedCategory("marketing")
}

export { CookieConsent }
